/**
 * nutmeg-parallax.js
 * Simple vertical scroll parallax for About Us section
 */
(function() {
  'use strict';
  function initParallax() {
    var containers = document.querySelectorAll('.nm-parallax-container');
    if (!containers.length) return;
    
    var ticking = false;

    function updateParallax() {
      var scrollY = window.pageYOffset;
      containers.forEach(function(container) {
        var rect = container.getBoundingClientRect();
        // Check if container is in viewport
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          var front = container.querySelector('.nm-parallax-front');
          var back = container.querySelector('.nm-parallax-back');
          
          // Calculate parallax offset based on distance from center of screen
          var centerOffset = (rect.top + rect.height / 2) - (window.innerHeight / 2);
          
          if (front) {
            front.style.transform = 'translateY(' + (centerOffset * -0.06) + 'px)';
          }
          if (back) {
            back.style.transform = 'translateY(' + (centerOffset * 0.04) + 'px)';
          }
        }
      });
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
    
    updateParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
